<template>
    <div class="page noScroll">
        <div class="userCoupon-menu">
            <ul>
                <li>
                    <a v-bind:class="{active: isExpired === 1}" @click="changeType(1)">可使用</a>
                    <span class="canUseCount" v-if="canUseCoupons.length > 0">{{canUseCoupons.length}}</span>
                </li>
                <li><a v-bind:class="{active: isExpired === 2}" @click="changeType(2)">已使用</a></li>
                <li><a v-bind:class="{active: isExpired === 3}" @click="changeType(3)">已过期</a></li>
            </ul>
        </div>
        <div class="page-content noScroll" id="userCoupon-infinite">
            <div v-if="this.currentCoupons.length > 0" class="userCoupon scroll-container">
                <div class="userCoupon-container">
                    <div class="userCoupon-wrap" v-bind:class="{active: isExpired === 1}">
                        <div v-for="item in canUseCoupons" :key="item.id" class="coupon-itemBody" @click="toOutside(item.skipUrl)">
                            <div class="coupon-itemConL">
                                <div class="coupon-itemTypeTxt">{{item.promotion}}</div>
                                <div class="coupon-itemExpiryDate">{{ item.expirationTime }}</div>
                                <div class="coupon-itemRule"><span class="coupon-itemRuleTxt useRuleBtn" @click.stop="showRule(item)">使用规则</span><span>券编号: {{item.token}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="userCoupon-wrap" v-bind:class="{active: isExpired === 2}">
                        <div class="coupon-itemBody used" v-for="item in usedCoupons" :key="item.id">
                            <div class="coupon-itemConL">
                                <div class="coupon-itemTypeTxt">{{item.promotion}}</div>
                                <div class="coupon-itemExpiryDate">{{ item.expirationTime }}</div>
                                <div class="coupon-itemRule"><span class="coupon-itemRuleTxt useRuleBtn" @click.stop="showRule(item)">使用规则</span><span>券编号: {{item.token}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="userCoupon-wrap" v-bind:class="{active: isExpired === 3}">
                        <div class="coupon-itemBody expired" v-for="item in expiredCoupons" :key="item.id">
                            <div class="coupon-itemConL">
                                <div class="coupon-itemTypeTxt">{{item.promotion}}</div>
                                <div class="coupon-itemExpiryDate">{{ item.expirationTime }}</div>
                                <div class="coupon-itemRule"><span class="coupon-itemRuleTxt useRuleBtn" @click.stop="showRule(item)">使用规则</span><span>券编号: {{item.token}}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="coupon-list-nodata scroll-container">
                <img src="https://resource.rcclchina.com.cn/tui2/user_center/coupon_empty.png" alt="">
                <p>
                    好可惜，这里空空如也~
                    <br>
                    您目前没有可用的优惠券哟
                </p>
                <div class="coupon-commonBtn-content">
                    <a class="coupon-commonBtn external" href="/Rccl.Cruise/CruiseSearch/Search">马上去看看</a>
                </div>
            </div>
            <PromoCruise></PromoCruise>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    export default {
        name: 'Coupon',
        components: {
            PromoCruise
        },
        data () {
            return {
                userToken: '',
                allCoupons: [],
                canUseCoupons: [],
                usedCoupons: [],
                expiredCoupons: [],
                isExpired: 1,
                isInWishList: true,
                currentCoupons: [],
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '优惠券')
            this.showPage()
        },
        beforeDestroy () {
            this.$store.commit('SET_POPUP', false)
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.isExpired = parseInt(`${this.$route.query.isExpired}`) || 1

                const userToken = this.$store.state.user.userToken
                if (!userToken && userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                this.userToken = userToken

                const coupons = await this.getCoupons(userToken)
                this.allCoupons = coupons
                this.canUseCoupons = coupons.filter(item => item.canUse === true)
                this.usedCoupons = coupons.filter(item => item.state === 2)
                this.expiredCoupons = coupons.filter(item => item.state === 1 && item.isExpired === true)

                this.currentCoupons = this.setCurrent(this.isExpired)
            },
            async getCoupons (userToken) {
                const {success, data, errMsg} = await api.user.getAllCoupons(userToken)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            changeType (type) {
                this.isExpired = type
                this.currentCoupons = this.setCurrent(type)
            },
            setCurrent (type) {
                switch (type) {
                    case 1:
                        return this.canUseCoupons
                    case  2:
                        return this.usedCoupons
                    case 3:
                        return this.expiredCoupons
                }
            },
            toOutside (url) {
              if(url) window.location.href = url
            },
            showRule (item) {
                this.$store.commit('SET_POPUP_CONTENT', item.rule)
                this.$store.commit('SET_POPUP', true)
            }
        }
    }
</script>

<style scoped>
    /****
     黄色：#eead11
    ****/

    .page-content{
        height: auto;
    }
    .page {
        display: block;
        background: #F6F7F8 !important;
    }


    /**** 优惠券页面****/
    ol {
        padding:0 16px;
    }
    .noborder {
        border: none !important;
    }
    .page-content {
        margin-top: 64px;
        padding-bottom: 50px;
        background-color: #fff;
        position: relative;
    }
    nav.home-bar-nav {
        background-color:#061556;
    }
    .userCoupon {
        background-color:#fff;
    }
    .userCoupon-menu {
        display: block;
        height: 50px;
        width: 100%;
        box-shadow: 0 1.5px 2px 0 #D6D7D8;
        position: absolute;
        top: 50px;
        z-index: 10;
        background-color: white;
    }
    .userCoupon-menu ul{
        list-style:none;
        margin:0;
        padding:0;
        display:inline-block;
        width: 100%;
        height: 100%;
    }
    .userCoupon-menu li {
        display: inline-block;
        vertical-align: middle;
        height: 100%;
        padding-top: 12px;
    }
    .userCoupon-menu li a {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #666;
        letter-spacing: 1px;
        text-align: center;
    }

    .userCoupon-menu .canUseCount {
        display: inline;
        width: 15px;
        height: 15px;
        background: #FF5055;
        color: white;
        border-radius: 8px;
        font-size: 12px;
        line-height: 15px;
        text-align: center;
        position: absolute;
        top: 17px;
        left: 71px;
    }

    .userCoupon-menu li:first-child {
        margin-left: 25px;
    }

    .userCoupon-menu li:nth-child(2) {
        margin:0px 91px;
    }

    .userCoupon-menu li a.active {
        color: #4A90E2;
        border-bottom: 2px solid #4A90E2;
        border-radius: 1px;
        padding-bottom: 14px;
    }


    .userCoupon {
        margin-top: 50px;
    }

    .show-coupon {
        background-color: #F6F7F8;
        padding: 10px 20px;
        display: none;
    }

    .show-coupon>div {
        display: inline-block;
        vertical-align: middle;
    }

    .show-coupon .show-coupon-title {
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        color: #666666;
    }

    .show-coupon .show-coupon-switch {
        margin-left: 7px;
        position: relative;
        top: 6px;
    }

    .userCoupon-container {
        margin-top:11px;
        width:100%;
    }
    .userCoupon-wrap{
        display: none;
    }
    .userCoupon-wrap.active{
        display: block;
    }
    .coupon-itemBody {
        margin: 0px 22px 10px 22px;
        background-color: transparent;
        background-image: url('https://resource.rcclchina.com.cn/tui2/user_center/coupon_can_use.png');
        background-size: 100% 100%;
        position: relative;
        height: 75px;
        color: #051555;
    }

    .coupon-itemBody.used {
        background-image: url('https://resource.rcclchina.com.cn/tui2/user_center/coupon_used.png');
        background-size: 100% 100%;
        color: #999;
    }

    .coupon-itemBody.expired {
        background-image: url('https://resource.rcclchina.com.cn/tui2/user_center/coupon_expired.png');
        background-size: 100% 100%;
        color: #999;
    }

    .coupon-itemBody.hasActive{
        background-color:#cacaca;
        color:#fff;
    }
    .coupon-itemBody .hold-link {
        position:absolute;
        left:0;
        top:0;
        width:100%;
        height:100%;
    }
    .coupon-itemBody.hasActive .coupon-itemTypeTxt,
    .coupon-itemBody.hasActive .coupon-itemTypeName,
    .coupon-itemBody.hasActive .coupon-itemRuleTxt{
        color:#fff;
    }
    .coupon-itemBody.hasActive .coupon-itemRuleTxt{
        border-bottom:1px solid #fff;
    }
    .coupon-itemBody .coupon-itemTypeTxt {
        font-family: PingFangSC-Semibold;
        font-size: 15px;
        letter-spacing: 0;
        margin-left: 10px;
        position: relative;
        top: 12px;
        max-width: 210px;
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .coupon-itemBody .coupon-itemTypeName {
        font-size:11px;
        color:#eead11;
    }
    .coupon-itemBody .coupon-itemExpiryDate {
        font-family: PingFang-SC-Medium;
        font-size: 11px;
        margin-left: 10px;
        margin-top: 12px;
        letter-spacing: 0;
    }
    .coupon-itemBody .coupon-itemRule {
        font-family: PingFang-SC-Medium;
        font-size: 11px;
        letter-spacing: 0;
    }
    .coupon-itemBody .coupon-itemRuleTxt {

        margin-left: 10px;
        margin-right: 10px;
        text-decoration: underline;

    }
    .coupon-itemBody .coupon-itemConR {
        float:left;
        border-left:1px dotted #fff;
        margin-bottom:-200px;
        padding:56px 0 200px 20px;
    }
    .coupon-itemBody .coupon-itemUseBtn {
        font-size:13px;
        color:#fff;
    }
    .coupon-itemBody .coupon-itemUseBtn a{
        font-size:13px;
        color:#fff;
    }
    .coupon-itemBody img{
        width:100%;
    }
    .coupon-itemBody  .coupon-itemHadUsed,
    .coupon-itemBody  .coupon-itemHadExpired{
        width:68px;
        height:60px;
        /*margin-top:12px;*/
    }
    .coupon-itemBody .coupon-itemCircleT {
        position:absolute;
        top:-6px;
        left:250px;
        width:12px;
        height:12px;
        border-radius:50%;
        background-color:#fff;
    }
    .coupon-itemBody .coupon-itemCircleB {
        position:absolute;
        bottom:-6px;
        left:250px;
        width:12px;
        height:12px;
        border-radius:50%;
        background-color:#fff;
    }

    /*toggle switch*/
    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 31px;
        height: 16px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        -webkit-transition: .4s;
        transition: .4s;
        background-color: #fff;
        border: 1px solid #ccc;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 15px;
        width: 15px;
        left: -2px;
        bottom: -1px;
        -webkit-transition: .4s;
        transition: .4s;
        background: #FFFFFF;
        border: 1px solid #CCCCCC;
        box-shadow: 0 1px 2.5px 0 rgba(0,0,0,0.30);
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(16px);
        -ms-transform: translateX(16px);
        transform: translateX(16px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }



    /*popup*/
    .popup {
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }

    .popup.modal-out {
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }

    div.content-block {
        padding: 0px;
        margin: 0px;
    }

    .pop-nav {
        display: block;
        position: relative;
        height: 50px;
    }

    .pop-nav a {
        width: 50px;
        position: absolute;
        display: block;
        height: 100%;
        z-index: 1;
    }

    .pop-nav a img {
        width: 10px;
        position: relative;
        left: 20px;
        top: 16px;
    }

    .pop-nav-title {
        position: relative;
        top: 15px;
        text-align: center;
    }

    .coupon-popup-bg {
        height: 10px;
        background-color: #F6F7F8;
    }

    #coupon-popup-content {
        padding: 14px 21px;
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        color: #666666;
        letter-spacing: 0;
        line-height: 20px;
    }

    #coupon-popup-content p {
        margin: 0px;
    }

    .coupon-list-nodata {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        color: #aaa;
        letter-spacing: 0;
        text-align: center;
        line-height: 20px;
        margin-top: 100px;
    }

    .coupon-list-nodata img{
        width:50px;
        margin:0 auto;
    }
    .coupon-list-nodata p {
        margin-top: 15px;
    }

    .coupon-list-nodata .coupon-commonBtn-content {
        margin-bottom: 20px;
    }

    .coupon-list-nodata .coupon-commonBtn{
        margin-top:10px;
        display:inline-block;
        border: 1px solid #4A90E2;
        border-radius: 14px;
        color: #4A90E2;
        width: 110px;
        line-height: 22px;
        text-decoration:none;
    }

    .cruiseBtn {
        text-align: center;
        margin-top: 25px;
        display: none;
    }

    .cruiseBtn a{
        width: 142px;
        height: 22px;
        border: 1px solid #4A90E2;
        border-radius: 27px;
        color: #4A90E2;
        font-size: 14px;
        display: block;
        margin: auto;
    }

</style>
